
export default function VoiceAssistant() {
  const handleOpenAssistant = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-indigo-950/30 to-slate-950">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-pulse"></div>
        </div>
      </div>

      <div className="relative z-10 container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Main Card */}
          <div className="bg-gradient-to-br from-indigo-900/40 to-purple-900/40 backdrop-blur-xl rounded-3xl border border-white/10 shadow-2xl overflow-hidden">
            <div className="p-12 text-center">
              {/* Icon */}
              <div className="mb-8 inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full shadow-lg shadow-purple-500/50 animate-pulse-slow">
                <i className="ri-customer-service-2-fill text-5xl text-white"></i>
              </div>

              {/* Title */}
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                Asistente Virtual <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">AVNEX</span>
              </h2>

              {/* Description */}
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
                Habla con nuestro asistente inteligente disponible 24/7. Agenda citas, resuelve dudas sobre nuestros servicios y obtén asesoría personalizada al instante.
              </p>

              {/* Features Grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all duration-300">
                  <div className="w-12 h-12 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-calendar-check-line text-2xl text-blue-400"></i>
                  </div>
                  <h3 className="text-white font-semibold mb-2">Agenda Citas</h3>
                  <p className="text-gray-400 text-sm">Programa reuniones en segundos</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all duration-300">
                  <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-question-answer-line text-2xl text-purple-400"></i>
                  </div>
                  <h3 className="text-white font-semibold mb-2">Resuelve Dudas</h3>
                  <p className="text-gray-400 text-sm">Respuestas instantáneas</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all duration-300">
                  <div className="w-12 h-12 bg-indigo-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-24-hours-line text-2xl text-indigo-400"></i>
                  </div>
                  <h3 className="text-white font-semibold mb-2">Disponible 24/7</h3>
                  <p className="text-gray-400 text-sm">Siempre a tu servicio</p>
                </div>
              </div>

              {/* CTA Button */}
              <button
                onClick={handleOpenAssistant}
                className="group relative px-6 py-4 md:px-10 md:py-5 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold text-base md:text-lg rounded-full hover:shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer w-full md:w-auto"
              >
                <span className="flex items-center justify-center gap-2 md:gap-3">
                  <i className="ri-mic-line text-xl md:text-2xl group-hover:animate-pulse"></i>
                  <span className="hidden sm:inline">Hablar con el Asistente</span>
                  <span className="sm:hidden">Hablar con Asistente</span>
                  <i className="ri-arrow-right-line text-xl md:text-2xl group-hover:translate-x-1 transition-transform"></i>
                </span>
              </button>

              {/* Subtitle */}
              <p className="text-gray-400 text-sm mt-6">
                <i className="ri-shield-check-line mr-2"></i>
                Conversación segura y confidencial
              </p>
            </div>

            {/* Bottom Accent */}
            <div className="h-2 bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500"></div>
          </div>

          {/* Floating Elements */}
          <div className="absolute -top-6 -left-6 w-12 h-12 bg-blue-500/30 rounded-full blur-xl animate-pulse"></div>
          <div className="absolute -bottom-6 -right-6 w-12 h-12 bg-purple-500/30 rounded-full blur-xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
      </div>

      <style>{`
        @keyframes pulse-slow {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
